import React from "react";
import { useDrop } from "react-dnd";
import AppConstants from "../../../constants/AppConstants";
import { generateDropSpec } from "../../../utils/DnDUtils";
import { ELEMENT_LAYER_ITEM } from "../../../constants/DnDConstants";
import { blockStateMarkerDrop } from "../SitePanelDropHandlers";
import styles from "./LayerPanelBlockState.module.css";

const { DROP_SHADOW_TOP } = AppConstants;

const LayerPanelBlockStateDropMarker = ({ id, height, index, onLayerMove }) => {
  const drop = generateDropSpec({
    type: ELEMENT_LAYER_ITEM,
    onDrop: blockStateMarkerDrop({ id, index, onLayerMove }),
  });

  const [{ isOver }, dropRef] = useDrop(drop);

  /**
   * @todo ADDRESS THE DROP MARKER HEIGHT!
   */

  const style = {
    height: height || 2,
  };

  isOver && (style.boxShadow = DROP_SHADOW_TOP);

  return (
    <div
      className={`layer-block-wrapper ${styles["layer-block-wrapper"]}`}
      ref={dropRef}
      style={style}
    />
  );
};

export default LayerPanelBlockStateDropMarker;
